import type { IconSvgObject } from './types';

const PieChart02Icon: IconSvgObject = [
  ["path", { d: "M11 22C15.9706 22 20 17.9706 20 13H11M11 22C6.02944 22 2 17.9706 2 13C2 8.02944 6.02944 4 11 4V13M11 22V13", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 10C22 5.58172 18.4183 2 14 2V10H22Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PieChart02Icon;
